import pagesBlueSvg from '../../assets/svg/Icons/48/pages-blue.svg';
import newsfeedBlueSvg from '../../assets/svg/Icons/48/newsfeed-blue.svg';

import slingHeaderUrl from './slingHeader.html';

const ICONS_MAP = {
  'pages-blue': pagesBlueSvg,
  'newsfeed-blue': newsfeedBlueSvg,
};

export default {
  controller: SlingHeaderController,
  controllerAs: 'ctrl',
  bindings: {
    icon: '@?',
    subtitle: '@?',
  },
  transclude: true,
  templateUrl: slingHeaderUrl,
};

function SlingHeaderController() {
  const controller = this;

  controller.$onInit = $onInit;

  function $onInit() {
    if (controller.icon) {
      controller.iconSrc = ICONS_MAP[controller.icon];
    }
  }
}
